import { fade } from "@remotion/transitions/fade";
import { slide } from "@remotion/transitions/slide";
import { wipe, WipeDirection } from "@remotion/transitions/wipe";
import { flip } from "@remotion/transitions/flip";
import { rotateTransition } from "../shared/utils/remotion/RemotionAnimations/rotationAnimation";
import { clockRotation } from "../shared/utils/remotion/RemotionAnimations/clockWiseRotationAnimation";
import { burstSlide } from "../shared/utils/remotion/RemotionAnimations/burstSlideAnimation";
import { burstWipe } from "../shared/utils/remotion/RemotionAnimations/burstWipeAnimations";
import { burstFlip } from "../shared/utils/remotion/RemotionAnimations/burstFlip";
import { shake } from "../shared/utils/remotion/RemotionAnimations/shakeAnimation";
import { glitch } from "../shared/utils/remotion/RemotionAnimations/glitchAnimation";
// import { swing } from '../shared/utils/RemotionAnimations/swingAnimation'
import { push } from "../shared/utils/remotion/RemotionAnimations/pushAnimation";
import { blurTransition } from "../shared/utils/remotion/RemotionAnimations/blurAnimation";
import { fadeTest } from "../shared/utils/remotion/RemotionAnimations/swingAnimation";
import { zoomIn } from "../shared/utils/remotion/RemotionAnimations/zoomInAnimation";
import { fadeToBlack } from "../shared/utils/remotion/RemotionAnimations/fadeInOut";
import { zoomOut } from "../shared/utils/remotion/RemotionAnimations/zoomOutAnimation";
import { fadeBlack, lightLeak } from "../shared/utils/remotion/RemotionAnimations/blackOutAndLightLeaq";

// import { zoomInFadeOut } from "../shared/utils/remotion/RemotionAnimations/zoomFadeTrannsition";

// import { fadeOut } from '@src/shared/utils/remotion/RemotionAnimations/fadeOutTransitions'

// import { curtain } from '@src/shared/utils/RemotionAnimations/curtainAnimation'
const wipeDirection: WipeDirection = "from-left";

// Default fade sound if no match found
const defaultTransitionSound = 'https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/1ccc0f5e-db47-4f06-a69a-328aece70014/audio.mp3';

export const transitionAnimationsDropDown = [
  {
    value: "fade",
    label: "Fade",
    functions: fade(),
    url: 'https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/1ccc0f5e-db47-4f06-a69a-328aece70014/audio.mp3'
  },
  {
    value: 'bottomwipe',
    label: 'Bottom Wipe',
    functions: wipe({direction:'from-top'}),
    url: 'https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/af03d121-acb7-473b-bdd6-39703bfa8300/audio.mp3'
  },
  {
    value: 'topwipe',
    label: 'Top Wipe',
    functions: wipe({direction:'from-bottom'}),
    url: 'https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/ca8b91b3-c464-4ea1-9ea3-bf36ea92864c/audio.mp3'
  },
  {
    value: 'bottomright',
    label: 'Bottom Right Wipe',
    functions: wipe({direction:'from-top-left'}),
    url: 'https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/1ccc0f5e-db47-4f06-a69a-328aece70014/audio.mp3'
  },
  {
    value: 'bottomleft',
    label: 'Bottom Left Wipe',
    functions: wipe({direction:'from-top-right'}),
    url: 'https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/658b75f8-95c2-436f-b319-18871c0991ab/audio.mp3'
  },
  {
    value: "slide",
    label: "Slide",
    functions: slide(),
    url: defaultTransitionSound
  },
  {
    value: "wipe",
    label: "Wipe",
    functions: wipe(),
    url: defaultTransitionSound
  },
  {
    value: "flip",
    label: "Flip",
    functions: flip(),
    url: 'https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/8f9a92e0-ba9d-4ad0-a038-9e9b8f874fa9/audio.mp3'
  },
  {
    value: "rotate",
    label: "Rotate",
    functions: rotateTransition(),
    url: 'https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/33b41b2f-60ea-4322-bc28-7d78a9c0c5e7/audio.mp3'
  },
  {
    value: "clock",
    label: "Clock",
    functions: clockRotation(),
    url: 'https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/bb43ced7-2fcd-4f0f-8aff-718ed829e1ec/audio.mp3'
  },
  {
    value: "shake",
    label: "Shake",
    functions: shake(),
    url: 'https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/e8449a48-42d0-4104-b466-a6d43d4d90d4/audio.mp3'
  },
  {
    value: "glitch",
    label: "Glitch",
    functions: glitch(),
    url: 'https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/b7f6f802-51af-442f-aa86-d09790b36777/audio.mp3'
  },
  {
    value: "blur",
    label: "Blur",
    functions: blurTransition(),
    url: defaultTransitionSound
  },
  {
    value: "zoomIn",
    label: "Zoom In",
    functions: zoomIn(),
    url: 'https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/f0a0eb2e-097e-49cb-805e-b5516cae5d52/audio.mp3'
  },
  {
    value: "zoomOut",
    label: "Zoom Out",
    functions: zoomOut(),
    url: 'https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/2b82aebe-5edf-43ff-9f2f-52c55597291d/audio.mp3'
  },
  {
    value: "diptoblack",
    label: "Dip to Black",
    functions: fadeBlack(),
    url: 'https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/e55708a8-2799-4acf-994e-9d517866c34a/audio.mp3'
  },
  {
    value: "lightleak",
    label: "Light Leak",
    functions: lightLeak(),
    url: 'https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/6047b065-7e65-4bf8-a659-ebd126c84106/audio.mp3'
  }
];

export const burstImageTransitionFunctions = [
  {
    value: "fade",
    function: fade(),
  },
  // Commented out transitions remain unchanged
  // {
  //   value: 'slide',
  //   function: slide(),
  // },
  // {
  //   value: 'slide',
  //   function: burstSlide(),
  // },
  // {
  //   value: 'wipe',
  //   function: burstWipe(),
  // },
  // {
  //   value: 'flip',
  //   function: burstFlip(),
  // },
  // {
  //   value: 'glitch',
  //   function: glitch(),
  // },
  // {
  //   value: 'blur',
  //   function: blurTransition(),
  // },
  // {
  //   value: 'rotate',
  //   function: rotateTransition(),
  // },
  // {
  //   value: 'shake',
  //   function: shake(),
  // },
];
